export default "__VITE_PUBLIC_ASSET__cd5ac5c6__"